import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import moment from "moment-timezone";

const noonReportApi = AiseaApiFactory.get("noonReport");


export default {

  async getReportSetting ({ _ }) {
    await noonReportApi.getConfigurations();
  },

  async getReportSearchParameter ({ commit }) {
    const res = await noonReportApi.getSearchParameter();
    if (!res || !res.data) throw res;

    let range = {
      start: moment().utc().subtract(30, "days").format("YYYY-MM-DD"),
      end: moment().utc().format("YYYY-MM-DD")
    }
    commit("SET_DATE_RANGE", range);

    if (res.data.vessel) {
      let options = []
      res.data.vessel.forEach(el => {
        options.push({
          id: el.enterprise_vessel_id,
          label: el.name,
        })
      });

      let plops = {
        options,
        multiple: true
      };
      commit("SET_SELECT_FORM_VESSEL_NAME_PROPS", plops);
    }

    if (res.data.sender) {
      let options = []
      res.data.sender.forEach(el => {
        options.push({
          id: el.account_id,
          label: el.name,
        })
      });

      let plops = {
        options,
        multiple: true
      };
      commit("SET_SELECT_FORM_SENDER_PROPS", plops);
    }

    if (res.data.status) {
      let options = []
      let colors = {}
      res.data.status.forEach(el => {
        options.push({
          id: el.label,
          label: el.label,
        })
        colors[el.label] = el.color || "#5B5E66"
      });

      commit("STATUS_COLOR_MAPPING", colors);

      let plops = {
        options,
        multiple: true
      };
      commit("SET_SELECT_FORM_STATUS_PROPS", plops);
    }
  },

  async getReports({state, commit, getters}) {
    const payload = {
      start_at: getters.dateRangeUTC.start,
      end_at: getters.dateRangeUTC.end,
      enterpriseVesselIds: getters.selectedVesselNames,
      senderAccountIds: getters.selectedSenders,
      statusLabels: getters.selectedStatus,
      page: getters.currentPage,
      limit: 100
    };

    const res = await noonReportApi.getReports(payload);
    if (!res || !res.data) throw res;

    commit("SET_REPORTS", res.data.reports);
    commit("SET_TOTAL_REPORT_COUNT", res.data.pageable.total_elements);
    commit("SET_TOTAL_PAGE", res.data.pageable.total_pages);
  },

  async resetState ({ commit }) {
    const defaultState = {
      reports: [],
      searchParameters: {},
      dateRange: {},
      selectFormVesselNameProps: null,
      selectedVesselNames: [],
      selectFormSenderProps: null,
      selectedSenders: [],
      selectFormStatusProps: null,
      selectedStatus: [],
      statusColorMapping: null,
      paginationPageSize: 100, //100固定
      currentPage: 0,
      totalReportCount: 0,
      totalPage: 0,
    };

    commit("RESET_STATE", defaultState)
  },

};
